export default {
  modal: {
    profile: {
      en: "Profile",
      pt: "Perfil",
    },
    exitQuestion: {
      en: "Are you sure you want to quit ?",
      pt: "Tem certeza que deseja sair ?",
    },
    changePassword: {
      en: "Change password",
      pt: "Alterar senha",
    },
  },
  user: {
    lastPassword: {
      en: "Last password",
      pt: "Senha antiga",
    },
    newPassword: {
      en: "New password",
      pt: "Nova senha",
    },
    editProfile: {
      en: "Edit Profile",
      pt: "Editar Perfil",
    },
    firstName: {
      en: "First Name",
      pt: "Primeiro Nome",
    },
    lastName: {
      en: "Last Name",
      pt: "Último Nome",
    },
    creation: {
      en: "Creation date",
      pt: "Data de criação",
    },
    numberOfGrammars: {
      en: "Number Of Grammars",
      pt: "Número de Gramáticas",
    },
    numberOfAutomatons: {
      en: "Number Of Automatons",
      pt: "Número de Autômatos",
    },
    attProfile: {
      en: "Update profile",
      pt: "Atualizar Perfil",
    },
    attPassword: {
      en: "Update password",
      pt: "Atualizar senha",
    },
    logout: {
      en: "Logout",
      pt: "Sair",
    },
    cancel: {
      en: "Cancel",
      pt: "Cancelar",
    },
  },
  alerts: {
    requiredPass: {
      en: "Password field is required",
      pt: "O campo senha é obrigatório",
    },
    succeed: {
      en: "User has been update",
      pt: "Usuário alterado com succeso",
    },
    wrongPass: {
      en: "Error to update user, please check your password",
      pt: "Erro ao atualizar usuário, cheque sua senha",
    },
    attPasswordSucceed: {
      en: "Password has been changed",
      pt: "Senha alterada com sucesso.",
    },
    attPasswordFail: {
      en: "Fail to change password.",
      pt: "Falha ao alterar senha.",
    },
  },
};
